var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.6665C10.8841 6.6665 11.7319 7.01769 12.357 7.64281C12.9822 8.26794 13.3334 9.11578 13.3334 9.99984C13.3334 10.4376 13.2471 10.871 13.0796 11.2754C12.9121 11.6799 12.6666 12.0473 12.357 12.3569C12.0475 12.6664 11.68 12.9119 11.2756 13.0794C10.8712 13.247 10.4378 13.3332 10 13.3332C9.11596 13.3332 8.26812 12.982 7.643 12.3569C7.01788 11.7317 6.66669 10.8839 6.66669 9.99984C6.66669 9.11578 7.01788 8.26794 7.643 7.64281C8.26812 7.01769 9.11596 6.6665 10 6.6665ZM10 0.666504C12.4754 0.666504 14.8493 1.64983 16.5997 3.40017C18.35 5.15051 19.3334 7.52448 19.3334 9.99984C19.3334 16.9998 10 27.3332 10 27.3332C10 27.3332 0.666687 16.9998 0.666687 9.99984C0.666687 7.52448 1.65002 5.15051 3.40036 3.40017C5.1507 1.64983 7.52467 0.666504 10 0.666504ZM10 3.33317C8.23191 3.33317 6.53622 4.03555 5.28597 5.28579C4.03573 6.53603 3.33335 8.23173 3.33335 9.99984C3.33335 11.3332 3.33335 13.9998 10 22.9465C16.6667 13.9998 16.6667 11.3332 16.6667 9.99984C16.6667 8.23173 15.9643 6.53603 14.7141 5.28579C13.4638 4.03555 11.7681 3.33317 10 3.33317Z",
    fill: "#007D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.8211a40bd8a820f976419d9335b645b6.svg";
export { ForwardRef as ReactComponent };